import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';
import messages from '../../MLSummary.messages'

import styles from '../../MLSummary.module.scss'
import { IconButton } from '@jutro/legacy/components';

function MLUmbrellaVehicleExposures({ data, show }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th>{translator(messages.Type)}</th>
                    <th>{translator(messages.Year)}</th>
                    <th>{translator(messages.Make)}</th>
                    <th>{translator(messages.Model)}</th>
                    <th>{translator(messages.Vin)}</th>
                    <th>{translator(messages.Excluded)}</th>
                </tr>
            </thead>
        );
    }

    const getExcluded = (excluded) => {
        if(excluded){
            return translator(messages.Yes);
        }
        return translator(messages.No);
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.VehicleExposures)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {data.map((vehicle) => {
                            return (
                                <>
                                    <tr>
                                        <td><strong>{vehicle.type}</strong></td>
                                        <td><strong>{vehicle.year}</strong></td>
                                        <td>{vehicle.make}</td>
                                        <td>{vehicle.model}</td>
                                        <td>{vehicle.vin}</td>
                                        <td>{getExcluded(vehicle.excluded)}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLUmbrellaVehicleExposures.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool
};
MLUmbrellaVehicleExposures.defaultProps = {
    data: [],
    show: false
};
export default MLUmbrellaVehicleExposures;
